export const articles = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子 酒店共度八小时被拍',
    slug: 'dingliu-nanxing-mi-hui',
    excerpt: '近日有媒体拍到某当红顶流男星深夜独自前往某高端酒店，随后一名神秘女子低调进入同一房间，两人在房间内共度长达八小时，直到次日清晨才先后离开。',
    content: `<h2>事件回顾</h2><p>近日，有知名娱乐媒体拍到了一组令人震惊的画面。某当红顶流男星在深夜时分独自驱车前往位于北京朝阳区的一家高端酒店。大约半小时后，一名身穿黑色连衣裙、戴着口罩和墨镜的神秘女子低调抵达酒店，径直走向了该男星所在的楼层房间。</p><p>据知情人士透露，两人在房间内<strong>共度了长达八个小时</strong>，直到第二天清晨六点左右才先后离开酒店。该男星离开时显得十分谨慎，特意从酒店后门离开，并更换了外套以避免被认出。</p><h2>网友热议</h2><p>此事一经曝光，立即在社交媒体上引发轩然大波。大量粉丝表示难以置信，纷纷在评论区留言表达震惊和失望。也有部分网友认为这是正常的私人社交，不应过度解读。</p><p>截至目前，该男星及其工作室尚未对此事作出任何回应。我们将持续关注事件的最新进展。</p>`,
    category: 'mingxing-bagua',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20atmosphere%20of%20a%20luxury%20hotel%20corridor%20at%20night%20with%20dim%20warm%20lighting%20and%20silhouette%20shadows%20cinematic%20mood%20editorial%20photography%20soft%20focus%20clean%20composition&width=800&height=450&seq=article-01&orientation=landscape',
    date: '2026-08-04',
    views: 125800,
    tags: ['顶流男星', '密会', '酒店', '绯闻'],
    featured: true,
    trending: true,
  },
  {
    id: 2,
    title: '知名女艺人被曝税务问题 工作室紧急发声明辟谣',
    slug: 'zhiming-nvyiren-shuiwu',
    excerpt: '近日网络上流传某知名女艺人涉嫌税务违规的消息，引发广泛关注。该女艺人的工作室在第一时间发布了严正声明，表示相关传言纯属造谣，将依法追究造谣者的法律责任。',
    content: `<h2>传言起因</h2><p>日前，有匿名网友在社交平台发布消息称，某知名一线女艺人因税务问题被相关部门约谈调查。该消息迅速在网络上传播，引发了大量网友的关注和讨论。</p><p>消息传出后，该女艺人的多个代言品牌的社交账号评论区被网友刷屏，不少网友要求品牌方给出明确说法。</p><h2>工作室回应</h2><p>面对愈演愈烈的舆论风波，该女艺人工作室在凌晨紧急发布了<strong>严正声明</strong>。声明中明确表示："近期网络上关于我司艺人税务问题的传闻纯属恶意造谣，严重损害了我司艺人的名誉权。我司已委托律师事务所对相关造谣者进行取证，并将依法追究其法律责任。"</p><p>律师也在声明中强调，网络并非法外之地，对于恶意散布不实信息的行为将坚决予以打击。</p>`,
    category: 'zuixin-baoliao',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20press%20conference%20scene%20with%20microphones%20and%20bright%20studio%20lights%20formal%20atmosphere%20clean%20composition%20professional%20photography&width=800&height=450&seq=article-02&orientation=landscape',
    date: '2026-08-03',
    views: 98700,
    tags: ['女艺人', '税务', '辟谣', '声明'],
    featured: true,
    trending: true,
  },
  {
    id: 3,
    title: '爆款综艺节目录制现场发生意外 节目组紧急暂停录制',
    slug: 'zongyi-luzhi-yiwai',
    excerpt: '某热门综艺节目在最新一期录制过程中发生意外事故，一名工作人员在搭建舞台道具时不慎受伤，节目组紧急叫停录制并将伤者送往医院救治。',
    content: `<h2>事故经过</h2><p>据现场目击者透露，事故发生在下午三点左右。当时节目组正在进行舞台道具的最后搭建工作，一名负责灯光设备的工作人员在脚手架上作业时，不慎失足跌落。</p><p>事故发生后，<strong>节目组第一时间拨打了急救电话</strong>，并紧急暂停了所有录制工作。受伤工作人员被迅速送往附近的医院进行救治。</p><h2>节目组回应</h2><p>当天晚间，该节目组通过官方社交账号发布了情况说明，确认确实发生了意外事故，并表示受伤工作人员目前情况稳定，正在接受进一步治疗。节目组同时承诺将全面排查安全隐患，确保后续录制工作的安全进行。</p>`,
    category: 'shehui-redian',
    image: 'https://readdy.ai/api/search-image?query=A%20television%20studio%20set%20with%20professional%20lighting%20equipment%20and%20stage%20props%20dramatic%20atmosphere%20warm%20tones%20editorial%20photography&width=800&height=450&seq=article-03&orientation=landscape',
    date: '2026-08-03',
    views: 76500,
    tags: ['综艺', '录制事故', '安全'],
    featured: false,
    trending: true,
  },
  {
    id: 4,
    title: '网红主播直播时突发翻车 口误曝光行业内幕引发轩然大波',
    slug: 'wanghong-zhibo-fanche',
    excerpt: '一位拥有千万粉丝的网红主播在直播带货过程中意外口误，不慎透露了产品的真实成本和行业的内幕操作，引发网友热烈讨论和行业震动。',
    content: `<h2>直播翻车始末</h2><p>昨晚的直播中，该网红主播正在向粉丝推荐一款高价护肤品。在介绍产品时，她不慎说出了"这个成本其实才几十块钱"的话语。虽然她立刻意识到口误并试图圆场，但这句话已经被大量观看直播的网友截图录屏。</p><p>此言一出，直播间评论区瞬间炸开了锅。大量网友纷纷表示"终于说了实话"，也有忠实粉丝为其辩解称只是一时口误。</p><h2>行业影响</h2><p>这次<strong>直播翻车事件</strong>在行业内引发了巨大震动。多位业内人士表示，网红直播带货的暴利问题一直是行业的公开秘密，但从未被如此直白地在公开场合被披露。</p><p>截至目前，该网红的社交账号评论区仍处于沦陷状态，多个品牌方也表示将重新评估与该网红的合作关系。</p>`,
    category: 'yiqu-erqu',
    image: 'https://readdy.ai/api/search-image?query=A%20live%20streaming%20setup%20with%20ring%20light%20and%20smartphone%20on%20tripod%20modern%20influencer%20studio%20warm%20lighting%20clean%20aesthetic%20editorial%20photography&width=800&height=450&seq=article-04&orientation=landscape',
    date: '2026-08-02',
    views: 213400,
    tags: ['网红', '直播翻车', '行业内幕', '带货'],
    featured: true,
    trending: true,
  },
  {
    id: 5,
    title: '两部古装大剧同时定档 网友：这个暑期档太精彩了',
    slug: 'guzhuang-daju-dingdang',
    excerpt: '备受期待的两部古装大制作剧集宣布将在同一天定档播出，两部剧都拥有顶级演员阵容和制作团队，网友纷纷表示这个暑期档竞争太激烈了。',
    content: `<h2>定档消息</h2><p>今日上午，两部备受瞩目的古装大剧先后通过官方渠道宣布了定档日期。巧合的是，两部剧都选择了8月15日作为首播日期，正式宣告<strong>暑期档终极之战</strong>的打响。</p><p>第一部是由实力派演员主演的历史正剧，改编自知名小说，投资超过五亿元，场景和服装都极为考究。第二部则是轻松甜宠风格的仙侠剧，由两位当红流量明星联袂出演。</p><h2>网友反应</h2><p>消息一出，两部剧的粉丝群体立刻在社交媒体上展开了热烈讨论。不少人表示这个暑期档的选择太多了，追剧追不过来。也有网友调侃道："这是要让观众的眼睛不够用啊！"</p>`,
    category: 'zaixian-guankan',
    image: 'https://readdy.ai/api/search-image?query=A%20grand%20ancient%20Chinese%20palace%20scene%20with%20elaborate%20costumes%20and%20ornate%20architecture%20cinematic%20lighting%20dramatic%20composition%20warm%20golden%20tones&width=800&height=450&seq=article-05&orientation=landscape',
    date: '2026-08-02',
    views: 89200,
    tags: ['古装剧', '定档', '暑期档', '电视剧'],
    featured: false,
    trending: false,
  },
  {
    id: 6,
    title: '某知名导演被曝片场耍大牌 剧组人员匿名爆料细节',
    slug: 'zhiming-daoyan-shuadapai',
    excerpt: '一位自称在某剧组工作的工作人员匿名爆料，称该剧组的知名导演在片场频繁发脾气，对演员和工作人员态度恶劣，甚至多次摔坏现场设备。',
    content: `<h2>匿名爆料</h2><p>昨日，一位自称在某热门剧组工作了三个月的匿名用户在社交平台发布了一篇长文，详细描述了该剧组知名导演在片场的种种不当行为。</p><p>根据爆料内容，这位导演在拍摄期间多次因小事大发雷霆，曾经因为一盏灯光的角度不对而<strong>当场摔坏了价值数万元的摄影设备</strong>。此外，该导演还多次用侮辱性语言指责演员的表演，导致多位年轻演员在片场落泪。</p><h2>业内反应</h2><p>此爆料一出，多位业内人士通过隐晦的方式对此进行了回应。有人表示这种情况在行业中并不少见，也有人呼吁行业应该建立更完善的片场行为规范。</p>`,
    category: 'yiqu-erqu',
    image: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20professional%20camera%20equipment%20and%20director%20chair%20tense%20atmosphere%20dramatic%20lighting%20cinematic%20mood%20dark%20warm%20tones&width=800&height=450&seq=article-06&orientation=landscape',
    date: '2026-08-01',
    views: 67800,
    tags: ['导演', '片场', '耍大牌', '爆料'],
    featured: false,
    trending: true,
  },
  {
    id: 7,
    title: '当红小花旦疑似整容 前后对比照引爆网络争论',
    slug: 'xiaohuadan-zhengrong',
    excerpt: '有网友扒出某当红小花旦的早年照片与近期照片进行对比，五官变化明显引发整容质疑。粉丝和网友各执一词，争论持续发酵。',
    content: `<h2>对比照流出</h2><p>近日，一组某当红小花旦的早年生活照在网络上被广泛传播。将这组照片与其近期出席活动的照片进行对比后，可以明显看出鼻子、下巴和脸型都发生了显著变化。</p><p>该组对比照迅速在各大社交平台传播，话题量在短时间内<strong>突破了千万阅读量</strong>，成为当日最热门的话题之一。</p><h2>两方争论</h2><p>粉丝方面坚称这些变化是自然成长和化妆技术的效果，并列举了多个角度的照片进行佐证。而质疑方则认为变化过于明显，不可能是自然发育的结果。截至目前，该女星本人尚未就此作出任何回应。</p>`,
    category: 'mingxing-bagua',
    image: 'https://readdy.ai/api/search-image?query=A%20glamorous%20celebrity%20red%20carpet%20moment%20with%20flashing%20cameras%20and%20elegant%20atmosphere%20soft%20glamorous%20lighting%20editorial%20fashion%20photography&width=800&height=450&seq=article-07&orientation=landscape',
    date: '2026-08-01',
    views: 156300,
    tags: ['小花旦', '整容', '对比照', '争议'],
    featured: true,
    trending: true,
  },
  {
    id: 8,
    title: '某视频平台被曝数据造假 实际播放量仅为显示的三分之一',
    slug: 'shipin-pingtai-shuju-zaojia',
    excerpt: '业内人士曝出某知名视频平台存在严重的数据造假行为，部分热门内容的实际播放量仅为平台显示数据的三分之一左右，广告主被蒙在鼓里。',
    content: `<h2>造假手段</h2><p>据知情人士透露，该平台使用了复杂的技术手段来夸大内容的播放数据。具体做法包括使用机器人账号自动播放、将自动播放的预告片计入正片播放量、以及通过后台直接修改数据等方式。</p><p>爆料人表示，根据其掌握的内部数据，某些被宣传为"播放量破十亿"的热门内容，其<strong>真实播放量可能不超过三亿</strong>。</p><h2>广告主反应</h2><p>此消息一出，多家在该平台投放广告的品牌方表示了严重关切。有广告代理公司透露，已经开始联系平台方要求提供第三方监测数据，并重新评估在该平台的广告投放策略。</p>`,
    category: 'shehui-redian',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20tech%20office%20with%20multiple%20computer%20screens%20displaying%20data%20charts%20and%20graphs%20dark%20atmosphere%20dramatic%20lighting%20cyber%20aesthetic&width=800&height=450&seq=article-08&orientation=landscape',
    date: '2026-07-31',
    views: 112500,
    tags: ['视频平台', '数据造假', '播放量'],
    featured: false,
    trending: false,
  },
  {
    id: 9,
    title: '选秀节目人气选手被曝黑历史 节目组态度暧昧引质疑',
    slug: 'xuanxiu-xuanshou-heilishi',
    excerpt: '某选秀节目当前排名第一的选手被网友挖出过往不当言论和照片，引发广泛争议。节目组对此事态度暧昧，未作出明确处理决定。',
    content: `<h2>黑历史曝光</h2><p>随着该选秀节目热度不断攀升，选手的过往经历也成为网友关注的焦点。近日，有网友在某论坛发布了该人气选手早年的社交动态截图，其中包含了一些不当言论和颇具争议的照片。</p><p>这些内容曝光后，立刻在网络上引发了<strong>激烈的讨论</strong>。一部分网友认为过去的言论不应影响现在的评价，另一部分则认为作为公众人物应该为自己的言行负责。</p><h2>节目组沉默</h2><p>面对日益增长的舆论压力，节目组至今未发表任何正式声明。这种暧昧态度进一步引发了观众的质疑，不少人认为节目组是在试图冷处理此事以保住该选手带来的流量。</p>`,
    category: 'zhan-guankan',
    image: 'https://readdy.ai/api/search-image?query=A%20talent%20show%20stage%20with%20colorful%20spotlights%20and%20dramatic%20atmosphere%20performance%20setting%20warm%20and%20cool%20contrasting%20lighting&width=800&height=450&seq=article-09&orientation=landscape',
    date: '2026-07-31',
    views: 143200,
    tags: ['选秀', '黑历史', '争议', '选手'],
    featured: true,
    trending: false,
  },
  {
    id: 10,
    title: '娱乐圈模范夫妻被曝已分居半年 经纪人回应模棱两可',
    slug: 'mofan-fuqi-fenju',
    excerpt: '一直被外界视为娱乐圈模范夫妻的一对明星夫妇，近日被曝已经分居长达半年之久。双方的经纪人对此事的回应十分暧昧，更加引发了外界的猜测。',
    content: `<h2>分居传闻</h2><p>据多位知情人士透露，这对明星夫妇实际上已经分居超过六个月。据悉，男方长期居住在位于市中心的公寓中，而女方则带着孩子住在了郊区的别墅里。两人最近一次公开同框还是在年初的一场品牌活动上。</p><p>消息人士还透露，两人之间的<strong>感情裂痕由来已久</strong>，主要原因是工作节奏差异过大以及家庭责任分配不均。</p><h2>经纪人回应</h2><p>当媒体就此事向双方经纪人求证时，得到的回应十分模棱两可。男方经纪人表示"艺人的私生活不方便透露"，女方经纪人则称"请多关注艺人的作品"，均未正面否认分居传闻。</p>`,
    category: 'mingxing-bagua',
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20modern%20living%20room%20with%20dim%20evening%20light%20and%20elegant%20decor%20feeling%20of%20emptiness%20and%20separation%20moody%20atmosphere%20editorial%20photography&width=800&height=450&seq=article-10&orientation=landscape',
    date: '2026-07-30',
    views: 187600,
    tags: ['模范夫妻', '分居', '婚姻', '明星'],
    featured: false,
    trending: true,
  },
  {
    id: 11,
    title: '重磅：某影视公司老板涉嫌经济犯罪被带走调查',
    slug: 'yingshi-laoban-jingji-fanzui',
    excerpt: '据可靠消息，某知名影视公司实际控制人因涉嫌经济犯罪被有关部门带走调查。该公司旗下拥有多位一线艺人，此事可能引发娱乐圈连锁反应。',
    content: `<h2>事件始末</h2><p>本周二下午，有关部门执法人员前往该影视公司总部，将公司实际控制人带走协助调查。据知情人士透露，此次调查可能涉及<strong>合同诈骗、非法集资</strong>等多重经济犯罪指控。</p><p>该公司是业内知名的综合性娱乐集团，旗下签约了多位一线明星艺人，同时还涉及影视制作、艺人经纪、音乐发行等多个业务板块。</p><h2>行业影响</h2><p>此事在业内引发了不小的震动。多位娱乐圈人士表示，如果该公司老板的罪名成立，可能会导致公司旗下多个项目停摆，数十位艺人的合约也将受到影响。有分析人士认为，这可能是娱乐圈整顿的又一重要信号。</p>`,
    category: 'zuixin-baoliao',
    image: 'https://readdy.ai/api/search-image?query=A%20serious%20business%20office%20building%20exterior%20at%20dusk%20with%20dramatic%20clouds%20and%80moody%20atmosphere%20corporate%20tension%20cinematic%20photography&width=800&height=450&seq=article-11&orientation=landscape',
    date: '2026-07-30',
    views: 234500,
    tags: ['影视公司', '经济犯罪', '调查', '娱乐圈'],
    featured: true,
    trending: true,
  },
  {
    id: 12,
    title: '某歌手新专辑被指抄袭 旋律与国外歌曲高度相似',
    slug: 'geshou-zhuanji-chaoxi',
    excerpt: '人气歌手发布的新专辑主打歌被乐评人指出旋律与某国外独立音乐人的作品高度相似，引发抄袭争议。歌手团队回应称纯属巧合。',
    content: `<h2>抄袭指控</h2><p>该歌手的新专辑在上线后迅速登上了各大音乐平台的排行榜榜首。然而，有专业乐评人在仔细聆听后指出，主打歌的副歌旋律与一首三年前发布的国外独立音乐作品<strong>几乎如出一辙</strong>。</p><p>该乐评人制作了详细的对比视频，将两首歌的副歌部分进行逐段比对，结果显示相似度极高。该视频发布后迅速获得了超过百万的播放量。</p><h2>团队回应</h2><p>面对铺天盖地的质疑声，该歌手团队发表声明称，创作者在创作过程中并未参考过该国外作品，旋律上的相似纯属巧合。团队同时表示，已经在联系音乐版权律师进行专业鉴定。</p>`,
    category: 'yiqu-erqu',
    image: 'https://readdy.ai/api/search-image?query=A%20recording%20studio%20with%20professional%20microphone%20and%20mixing%20console%20warm%20ambient%20lighting%20creative%20atmosphere%20music%20production%20scene&width=800&height=450&seq=article-12&orientation=landscape',
    date: '2026-07-29',
    views: 98700,
    tags: ['歌手', '抄袭', '专辑', '争议'],
    featured: false,
    trending: false,
  },
  {
    id: 13,
    title: '某品牌代言人突然解约 背后原因竟与竞品有关',
    slug: 'daiyanren-jieyue-neimu',
    excerpt: '某知名品牌与其代言人的合作突然终止，外界猜测纷纷。知情人透露解约背后涉及复杂的竞品排他条款冲突，并非简单的合作到期。',
    content: `<h2>突然解约</h2><p>昨日，某知名国际品牌在毫无征兆的情况下宣布与其中国区代言人终止合作。双方的合作原本还有一年才到期，此次突然解约让外界十分意外。</p><p>该代言人近两年人气飙升，商业价值持续走高，按理说品牌方没有提前终止合作的动机。</p><h2>内幕揭晓</h2><p>据接近该代言人团队的消息人士透露，解约的真正原因是<strong>代言人私下接了该品牌竞品的一个商业活动</strong>，这触发了代言合同中严格的排他条款。品牌方在多次沟通无果后，选择直接终止合作。此事也提醒了其他艺人，签订代言合同后需要格外注意排他条款的约束。</p>`,
    category: 'zhan-guankan',
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20brand%20billboard%20advertisement%20in%20a%20modern%20city%20street%20dramatic%20contrast%20between%20commercial%20and%20personal%20editorial%20photography&width=800&height=450&seq=article-13&orientation=landscape',
    date: '2026-07-29',
    views: 76500,
    tags: ['代言人', '解约', '品牌', '内幕'],
    featured: false,
    trending: false,
  },
  {
    id: 14,
    title: '某热播剧因剧情争议被要求停播整改 编剧团队紧急修改',
    slug: 'reboju-tingbo-zhenggai',
    excerpt: '近期热播的一部都市剧因涉及敏感话题和不当价值观引发争议，被有关部门要求暂停播出并进行整改。编剧团队正在紧急修改后续剧情。',
    content: `<h2>争议焦点</h2><p>该都市剧自播出以来收视率一路走高，但最近几集中涉及的一些情节引发了部分观众的强烈不满。争议主要集中在剧中出现的不当价值导向以及对社会敏感话题的处理方式上。</p><p>多个社交媒体平台上出现了大量批评该剧的声音，话题标签一度登上了热搜榜。</p><h2>整改要求</h2><p>在舆论压力下，有关部门向制作方发出了<strong>暂停播出并要求整改</strong>的通知。据悉，编剧团队已经紧急召开了多轮会议，正在对后续剧本进行大幅修改。平台方也在第一时间下架了引发争议的剧集，等待整改完成后重新上线。</p>`,
    category: 'zaixian-guankan',
    image: 'https://readdy.ai/api/search-image?query=A%20television%20screen%20displaying%20static%20or%20pause%20symbol%20in%20a%20dark%20living%20room%20moody%20atmosphere%20dramatic%20tension%20editorial%20photography&width=800&height=450&seq=article-14&orientation=landscape',
    date: '2026-07-28',
    views: 198300,
    tags: ['热播剧', '停播', '整改', '争议'],
    featured: true,
    trending: false,
  },
  {
    id: 15,
    title: '短视频平台网红因发布不当内容被全网封禁',
    slug: 'duanshipin-wanghong-fengjin',
    excerpt: '一位在短视频平台拥有超过两千万粉丝的网红因连续发布多条不当内容，被多家平台联合封禁。平台方表示将加强对内容的审核力度。',
    content: `<h2>封禁原因</h2><p>据悉，该网红在最近一周内连续发布了多条涉嫌低俗和违规的内容，虽然平台多次进行了警告和处理，但该网红并未收敛。最终，多家平台决定<strong>联合对其进行永久封禁处理</strong>。</p><p>该网红被封禁的消息迅速登上了热搜，大量网友表示支持平台的决定，认为这种以低俗内容博取流量的行为应该被严厉打击。</p><h2>平台表态</h2><p>相关平台在封禁公告中表示，将一如既往地坚持内容安全底线，对于屡次违规的账号将采取最严厉的处理措施。同时，平台也呼吁广大创作者遵守社区规范，共同维护清朗的网络空间。</p>`,
    category: 'shehui-redian',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20account%20suspended%20notification%20on%20a%20dark%20desk%20dramatic%20red%20and%20dark%20lighting%20moody%20digital%20atmosphere&width=800&height=450&seq=article-15&orientation=landscape',
    date: '2026-07-28',
    views: 289100,
    tags: ['短视频', '网红', '封禁', '违规'],
    featured: false,
    trending: true,
  },
  {
    id: 16,
    title: '某综艺节目选手淘汰内幕曝光 节目组疑似操控比赛结果',
    slug: 'zongyi-taotai-neimu',
    excerpt: '一档正在热播的竞技类综艺节目被已淘汰选手曝光比赛结果被操控。该选手称节目组在录制前就确定了淘汰名单，比赛只是走过场。',
    content: `<h2>淘汰选手爆料</h2><p>该选手在被淘汰后，通过个人社交账号发布了一段长达十分钟的视频，详细描述了节目录制过程中的种种"安排"。据其透露，节目组在每轮比赛录制前就已经<strong>提前通知了淘汰人选</strong>，所谓的现场比赛和投票实际上都是按照既定剧本进行的。</p><p>该选手还提供了部分与节目组工作人员的聊天记录截图作为佐证，虽然截图中的关键信息被打了马赛克，但仍然引发了广泛讨论。</p><h2>节目组沉默</h2><p>截至目前，该节目组尚未就此事作出正式回应。但值得注意的是，该选手发布视频后不久，其社交账号就出现了异常，部分内容被下架处理。</p>`,
    category: 'yiqu-erqu',
    image: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20view%20of%20a%20TV%20competition%20show%20with%20dramatic%20stage%20lighting%20and%20crew%20members%20dark%20moody%20backstage%20atmosphere&width=800&height=450&seq=article-16&orientation=landscape',
    date: '2026-07-27',
    views: 176400,
    tags: ['综艺', '内幕', '淘汰', '操控'],
    featured: false,
    trending: true,
  },
  {
    id: 17,
    title: '当红小生被拍到与经纪人深夜回公寓 恋情疑云再起',
    slug: 'danghong-xiaosheng-lianqing',
    excerpt: '有媒体拍到某当红小生深夜与女经纪人一同返回公寓，两人举止亲密，直到次日早晨经纪人才独自离开。此前两人就曾多次传出绯闻。',
    content: `<h2>最新画面</h2><p>近日，有八卦媒体拍到了一组引人遐想的画面。某当红小生在结束一天的工作后，与女经纪人一同乘车返回了位于市中心的高档公寓。两人在进入公寓大楼时<strong>举止亲密，有说有笑</strong>。</p><p>更令人关注的是，记者蹲守发现该经纪人直到第二天早晨七点左右才独自离开公寓，并换了一身与前晚不同的衣服。</p><h2>绯闻历史</h2><p>这并非两人第一次传出绯闻。早在去年，就有网友发现两人在社交媒体上的互动频繁，且多次被拍到单独外出用餐。不过双方此前均否认了恋情传闻，称只是正常的工作关系。</p>`,
    category: 'mingxing-bagua',
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20apartment%20building%20entrance%20at%20night%20with%20warm%20interior%20lighting%20and%20city%20skyline%20background%20romantic%20mood%20cinematic%20photography&width=800&height=450&seq=article-17&orientation=landscape',
    date: '2026-07-27',
    views: 134200,
    tags: ['当红小生', '经纪人', '恋情', '绯闻'],
    featured: false,
    trending: false,
  },
  {
    id: 18,
    title: '某国际电影节入围名单公布 中国电影占三席创历史新高',
    slug: 'guoji-dianyingjie-ruwei',
    excerpt: '某国际A类电影节公布了今年的入围名单，中国电影共有三部作品入围主竞赛单元，创下了该电影节历史上中国电影入围数量的新纪录。',
    content: `<h2>入围名单</h2><p>今日凌晨，备受关注的某国际A类电影节公布了今年的完整入围名单。在主竞赛单元的二十部入围影片中，<strong>中国电影占据了三席</strong>，这是该电影节创办以来中国电影入围数量最多的一届。</p><p>三部入围影片分别来自三位不同年龄段的导演，涵盖了历史题材、现实主义题材和实验性作品，展现了中国电影的多元面貌。</p><h2>行业反响</h2><p>消息传回国内后，电影界人士纷纷表达了欣喜之情。多位资深影评人表示，这标志着中国电影在国际舞台上的影响力正在稳步提升，是多年来行业共同努力的成果。</p>`,
    category: 'zuixin-baoliao',
    image: 'https://readdy.ai/api/search-image?query=A%20prestigious%20film%20festival%20red%20carpet%20entrance%20with%20golden%20decorations%20and%20grand%20atmosphere%20elegant%20lighting%20celebratory%20mood&width=800&height=450&seq=article-18&orientation=landscape',
    date: '2026-07-26',
    views: 56700,
    tags: ['电影节', '入围', '中国电影', '国际'],
    featured: false,
    trending: false,
  },
  {
    id: 19,
    title: '某电商主播涉嫌虚假宣传被罚款 金额高达千万级别',
    slug: 'dianshang-zhubo-xujia-xuanchuan',
    excerpt: '一位头部电商主播因在直播中多次进行虚假宣传和夸大产品功效，被市场监管部门处以高额罚款。这是近半年来第四位被处罚的头部主播。',
    content: `<h2>处罚详情</h2><p>市场监管部门在经过数月的调查取证后，对该电商主播作出了<strong>罚款一千二百万元</strong>的行政处罚决定。调查发现，该主播在直播带货过程中对多款产品的功效进行了严重夸大，部分宣称效果完全没有科学依据。</p><p>此外，该主播还被发现在宣传中使用"全网最低价"等绝对化用语，且无法提供相应的证明材料，构成了虚假宣传行为。</p><h2>行业震动</h2><p>这是近半年以来第四位遭到处罚的头部电商主播，处罚力度呈现逐步加大的趋势。业内人士分析认为，监管部门正在释放明确信号，电商直播行业将迎来更加严格的合规监管时代。</p>`,
    category: 'shehui-redian',
    image: 'https://readdy.ai/api/search-image?query=A%20serious%20government%20official%20document%20with%20red%20stamp%20on%20a%20desk%20under%20harsh%20office%20lighting%20regulatory%20atmosphere%20clean%20composition&width=800&height=450&seq=article-19&orientation=landscape',
    date: '2026-07-26',
    views: 145800,
    tags: ['电商', '虚假宣传', '罚款', '监管'],
    featured: true,
    trending: false,
  },
  {
    id: 20,
    title: '独家：某流量明星私下慈善捐款超千万 低调行善不张扬',
    slug: 'liuliang-mingxing-cishan',
    excerpt: '本网独家获悉，某位拥有数千万粉丝的流量明星在过去三年间低调地向多个慈善机构捐款累计超过千万元，从未主动对外宣传。',
    content: `<h2>慈善真相</h2><p>在娱乐圈充斥着各种负面新闻的当下，本网独家挖到了一个温暖的故事。据多个慈善机构的工作人员证实，该流量明星在过去三年间，通过个人名义和工作室名义，累计向<strong>超过二十家慈善机构</strong>捐款超过一千万元。</p><p>这些捐款涵盖了教育助学、大病救助、灾害救援等多个领域，且该明星从未在任何公开场合主动提及自己的慈善行为，也从未借此进行任何商业宣传。</p><h2>工作人员证言</h2><p>一位受助机构的负责人表示："他们每次捐款都特别低调，从来不让宣传。有时候我们想发个感谢信，对方都会婉拒，说'能做一点是一点'，真的很让人感动。"</p>`,
    category: 'zuixin-baoliao',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20heartfelt%20scene%20of%20charity%20and%20giving%20with%20soft%20golden%20sunlight%20through%20window%20peaceful%20hopeful%20atmosphere%20editorial%20photography&width=800&height=450&seq=article-20&orientation=landscape',
    date: '2026-07-25',
    views: 198700,
    tags: ['流量明星', '慈善', '捐款', '正能量'],
    featured: true,
    trending: true,
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug);
};

export const getFeaturedArticles = () => {
  return articles.filter((a) => a.featured);
};

export const getTrendingArticles = () => {
  return articles.filter((a) => a.trending);
};

export const getRelatedArticles = (currentSlug: string, category: string, limit: number = 4) => {
  return articles
    .filter((a) => a.slug !== currentSlug && a.category === category)
    .slice(0, limit);
};